export const CPT_CODES = [
  // Row 1: Established patients (EST.)
  { code: "99213", label: "99213", description: "Established Patient, Level 3", type: "EST.", level: 3, wrvu: 1.30 },
  { code: "99214", label: "99214", description: "Established Patient, Level 4", type: "EST.", level: 4, wrvu: 1.92 },
  { code: "99215", label: "99215", description: "Established Patient, Level 5", type: "EST.", level: 5, wrvu: 2.80 },
  // Row 2: New patients
  { code: "99203", label: "99203", description: "New Patient, Level 3", type: "New", level: 3, wrvu: 1.60 },
  { code: "99204", label: "99204", description: "New Patient, Level 4", type: "New", level: 4, wrvu: 2.60 },
  { code: "99205", label: "99205", description: "New Patient, Level 5", type: "New", level: 5, wrvu: 3.50 },
];

export const WRVU_MAP = Object.fromEntries(CPT_CODES.map(c => [c.code, c.wrvu]));

export const DEFAULT_TALLIES = Object.fromEntries(CPT_CODES.map(c => [c.code, 0]));

export function getColorClasses(code) {
  const cpt = CPT_CODES.find(c => c.code === code);
  if (!cpt) return "bg-slate-500/10 text-slate-400 border-slate-500/30";
  if (cpt.level === 3) return "bg-blue-500/10 text-blue-400 border-blue-500/30 hover:border-blue-400/60";
  if (cpt.level === 4) return "bg-emerald-500/10 text-emerald-400 border-emerald-500/30 hover:border-emerald-400/60";
  if (cpt.level === 5) return "bg-orange-500/10 text-orange-400 border-orange-500/30 hover:border-orange-400/60";
  return "bg-slate-500/10 text-slate-400 border-slate-500/30 hover:border-slate-400/60";
}

export function getAccentColor(code) {
  const cpt = CPT_CODES.find(c => c.code === code);
  if (!cpt) return "text-slate-400";
  if (cpt.level === 3) return "text-blue-400";
  if (cpt.level === 4) return "text-emerald-400";
  if (cpt.level === 5) return "text-orange-400";
  return "text-slate-400";
}

export function getBadgeBg(code) {
  const cpt = CPT_CODES.find(c => c.code === code);
  if (!cpt) return "bg-slate-500/20";
  if (cpt.level === 3) return "bg-blue-500/20";
  if (cpt.level === 4) return "bg-emerald-500/20";
  if (cpt.level === 5) return "bg-orange-500/20";
  return "bg-slate-500/20";
}

export function calculateTotals(tallies, miscEntries = []) {
  const tallyPatients = Object.values(tallies).reduce((a, b) => a + b, 0);
  const miscPatients = miscEntries.length;
  const totalPatients = tallyPatients + miscPatients;

  const tallyWrvus = Object.entries(tallies).reduce(
    (sum, [code, count]) => sum + count * (WRVU_MAP[code] || 0),
    0
  );
  const miscWrvus = miscEntries.reduce(
    (sum, entry) => sum + (parseFloat(entry.wrvus) || 0),
    0
  );
  const totalWrvus = Math.round((tallyWrvus + miscWrvus) * 100) / 100;
  return { totalPatients, totalWrvus };
}

// Format number with commas (e.g., 1234.56 -> "1,234.56")
export function formatNumber(num, decimals = 2) {
  if (num === null || num === undefined || isNaN(num)) return "0.00";
  return num.toLocaleString('en-US', { 
    minimumFractionDigits: decimals, 
    maximumFractionDigits: decimals 
  });
}

// Format currency with commas (e.g., 1234.56 -> "$1,234.56")
export function formatCurrency(num) {
  if (num === null || num === undefined || isNaN(num)) return "$0.00";
  return "$" + num.toLocaleString('en-US', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
}
